var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild, ElementRef } from '@angular/core';
import { TeamService } from './subapps/tour-of-heroes/services/team.service';
import { TeamFirebaseProvider } from "./subapps/tour-of-heroes/providers/team-firebase-provider.service";
import { TeamProvider } from "./subapps/tour-of-heroes/providers/team-provider.service";
import { SbRouterService } from "./nav/sb-router.service";
export var AppComponent = (function () {
    function AppComponent() {
        this.title = '';
    }
    AppComponent.prototype.ngOnInit = function () {
        console.log(this.mainContainer);
        var hammertime = new Hammer(this.mainContainer.nativeElement);
        hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
        hammertime.get('pan').set({ direction: Hammer.DIRECTION_ALL });
        // hammertime.on('pan', function (ev) {
        //     console.log(ev);
        // });
    };
    __decorate([
        ViewChild("mainContainer"), 
        __metadata('design:type', ElementRef)
    ], AppComponent.prototype, "mainContainer", void 0);
    AppComponent = __decorate([
        Component({
            selector: 'my-app',
            template: "\n    <my-nav></my-nav>\n\t<div id=\"mainContainer\" #mainContainer class=\"container\">\n      <router-outlet></router-outlet>\n\t</div>\n  ",
            providers: [{ provide: TeamProvider, useClass: TeamFirebaseProvider }, TeamService, SbRouterService]
        }), 
        __metadata('design:paramtypes', [])
    ], AppComponent);
    return AppComponent;
}());
//# sourceMappingURL=app.component.js.map